import { Component, computed, effect, input, output, Signal, inject } from '@angular/core';
import { CardLimits } from '../../../../_interfaces/cards.interface';
import { CurrencyPipe, NgClass } from '@angular/common';
import { CardTopupsService } from '../../../../_services/topup-service/card-topups.service';
import { TopUpFrequency } from '../../../../_interfaces/employee.interface';
import { EmptyIndicatorPipe } from '../../../pipes/empty-indicator.pipe';

@Component({
  selector: 'app-card-limit-display',
  imports: [NgClass, CurrencyPipe, EmptyIndicatorPipe],
  template: `
    <div
      [ngClass]="{ 'd-block mt-neg-2 mb-3': cardLimitError() }"
      class="invalid-feedback">
      Amount cannot exceed the target balance.
    </div>
    @if (cardLimits()) {
      <div class="card border-secondary mb-4">
        <div class="card-body p-2">
          <p
            class="mb-0 text-muted"
            [ngClass]="{ 'showLimitError': cardLimitError() }">
            Please note the target balance cannot be more than the following: <br />
            <span [ngClass]="{ 'highlight': selectedFrequency() === TopUpFrequency.Daily }">
              Daily: {{ cardLimits()?.daily | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            </span>
            <br />
            <span [ngClass]="{ 'highlight': selectedFrequency() === TopUpFrequency.Weekly }">
              Weekly: {{ cardLimits()?.weekly | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            </span>
            <br />
            <span [ngClass]="{ 'highlight': selectedFrequency() === TopUpFrequency.Monthly }">
              Monthly: {{ cardLimits()?.monthly | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            </span>
          </p>
        </div>
      </div>
    }
  `,
})
export class CardLimitDisplayComponent {
  protected cardTopupsService = inject(CardTopupsService);

  protected cardLimits: Signal<CardLimits | null> = computed(() => this.cardTopupsService.cardLimits());
  selectedFrequency = input.required<TopUpFrequency>();
  amount = input.required<number>();
  hasCardLimitError = output<boolean>();

  protected getSelectedCardLimit = computed(() => {
    const limits = this.cardLimits();
    if (!limits) return 0;
    const mapping: Record<TopUpFrequency, number> = {
      [TopUpFrequency.Daily]: limits.daily,
      [TopUpFrequency.Weekly]: limits.weekly,
      [TopUpFrequency.Monthly]: limits.monthly,
    };
    return mapping[this.selectedFrequency()] ?? 0;
  });

  protected cardLimitError = computed(() => {
    return this.amount() > this.getSelectedCardLimit();
  });

  constructor() {
    effect(() => {
      const isError = this.cardLimitError();
      this.hasCardLimitError.emit(isError);
    });
  }

  protected readonly TopUpFrequency = TopUpFrequency;
}
